import { ExcelExportParams, ValueFormatterParams } from '@ag-grid-community/core';

import { Currency } from '@shared/services/gql.service';
import { InvoiceLineItem, InvoiceModel } from '@shared/store/invoice/invoice.model';
import { decimalAdd } from '@shared/utils';
import { Utils } from '@shared/utils/utils';

export const DefaultColumns = (invoice: InvoiceModel) => [
  {
    cellClass: '!block text-left max-w whitespace-nowrap overflow-hidden text-ellipsis',
    field: 'description',
    flex: 2,
    headerName: 'Description',
    minWidth: 300,
    resizable: true,
    tooltipField: 'description',
  },
  {
    cellClass: () => {
      if (invoice.organization?.currency) {
        return [`budgetCost${invoice.organization?.currency}`, 'ag-cell-align-right'];
      }

      return ['budgetCostNoSymbol', 'ag-cell-align-right'];
    },
    field: 'amount',
    flex: 1,
    headerClass: 'ag-header-align-center justify-center font-bold',
    headerName: 'Total Amount',
    minWidth: 200,
    resizable: true,
    valueFormatter: (params: ValueFormatterParams) => {
      return Utils.agCurrencyFormatterAccounting(
        params,
        invoice.organization?.currency || Currency.USD
      );
    },
  },
];

export const ExcelOptions: ExcelExportParams = {
  author: 'Auxilius',
  columnWidth(params) {
    switch (params.column?.getId()) {
      case 'description':
        return 400;
      default:
        return 200;
    }
  },
  fontSize: 11,
  sheetName: 'Invoice Line Items',
  skipPinnedBottom: true,
};

export const calculatePinnedBottomData = (gridData: InvoiceLineItem[]) => {
  const amountKey: keyof InvoiceLineItem = 'amount';
  const descriptionKey = 'description';

  const totalAmount = gridData.reduce((acc, currentRecord) => {
    const amt = currentRecord[amountKey];

    if (Utils.isNumber(amt)) {
      acc = decimalAdd(acc, amt);
    }

    return acc;
  }, 0);

  return { [amountKey]: totalAmount, [descriptionKey]: 'Total' };
};
